import React from 'react';
import { OrdersQueryProvider } from './list/OrdersQueryProvider';

export const OrdersProviders = ({ children }: any) => {
	return <OrdersQueryProvider>{children}</OrdersQueryProvider>;
};
